import React, { Component } from 'react';
import TaxAuthorityStep1Page from './tax-authority-step1-html';
class TaxAuthorityStep1 extends Component {
    constructor(props) {
        super(props)
        window.scrollTo({ top: 0, behavior: 'smooth' })
    }
    render() {
        return (
            <div>
                <TaxAuthorityStep1Page
                />
            </div>
        )
    }
}
export default TaxAuthorityStep1;